import { Subject } from "../../types/types";
import { createUseDocument } from "../../utils/other/create-use-document";

export const useSubject = createUseDocument<Subject>('subjects')